var _ellipse, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVisitor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.4,
    cx: 10.614,
    cy: 6.21324,
    rx: 4.37986,
    ry: 4.37986,
    stroke: "#1C3C54",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.66664 16.6846C3.66546 16.3767 3.73432 16.0726 3.86801 15.7952C4.28754 14.9561 5.47061 14.5114 6.4523 14.3101C7.1603 14.159 7.87807 14.058 8.60028 14.008C9.93739 13.8906 11.2822 13.8906 12.6193 14.008C13.3415 14.0586 14.0592 14.1596 14.7673 14.3101C15.749 14.5114 16.9321 14.9142 17.3516 15.7952C17.6205 16.3606 17.6205 17.017 17.3516 17.5824C16.9321 18.4634 15.749 18.8661 14.7673 19.0591C14.0602 19.2165 13.3421 19.3202 12.6193 19.3696C11.531 19.4618 10.4377 19.4786 9.34704 19.4199C9.09532 19.4199 8.852 19.4199 8.60028 19.3696C7.8802 19.3208 7.16492 19.2171 6.46069 19.0591C5.47061 18.8661 4.29593 18.4634 3.86801 17.5824C3.73501 17.3018 3.66622 16.9951 3.66664 16.6846Z",
    stroke: "#1C3C54",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisitor);
export default __webpack_public_path__ + "static/media/visitor.590d667af239d7efc8a5d058f56d60ed.svg";
export { ForwardRef as ReactComponent };